import { render, staticRenderFns } from "./DayOfTheWeek.vue?vue&type=template&id=91623d48&scoped=true"
import script from "./DayOfTheWeek.vue?vue&type=script&lang=js"
export * from "./DayOfTheWeek.vue?vue&type=script&lang=js"
import style0 from "./DayOfTheWeek.vue?vue&type=style&index=0&id=91623d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91623d48",
  null
  
)

export default component.exports